import { NumberUtils } from 'utils/numberUtils';

export namespace MintApiUtils {
  export function calculateCollateralAndMemberUsdValues(
    amount: string,
    mintingRatio = 1,
    mintingFee = 0
  ) {
    const amountNumber = NumberUtils.stringToBN(amount, 18n);

    // TODO: handle maxOrderVolume

    // const mintingRatio = args.mintingRatio ? args.mintingRatio : 1;
    // const mintingFee = args.mintingFee ? args.mintingFee : 0;

    // TODO - Consider calling collateral token oracle here, for now we assume collateral is at $1
    // calculate required collateral and member token amounts
    let collateralUSDValue =
      (amountNumber * BigInt(mintingRatio * 10000)) / 10000n;
    const memberTokensUSDValue = amountNumber - collateralUSDValue;
    collateralUSDValue =
      collateralUSDValue + (amountNumber * BigInt(mintingFee * 10000)) / 10000n;

    return {
      collateralUSDValue,
      memberTokensUSDValue,
    };
  }

  export function isMemberApproved(
    memberAllowance: bigint,
    memberTokensReq: string
  ): boolean {
    const result = memberAllowance >= BigInt(memberTokensReq);
    return result;
  }

  export function isSufficientMemberToken(
    memberTokenBalance: bigint,
    memberTokensReq: string
  ): boolean {
    // result = Number(memberTokenBalance) >= Number(memberTokensReq);
    const result = memberTokenBalance >= BigInt(memberTokensReq);
    //  console.log("isSufficientMemberToken = "+isSufficientMemberToken);
    return result;
  }

  export function isCollateralApproved(
    collateralAllowance: bigint,
    decimals: number,
    collateralTokensReq: bigint
  ): boolean {
    const value = collateralAllowance * BigInt(10 ** (18 - decimals));
    // isCollateralApproved = Number(collateralAllowance) >= Number(collateralTokensReq);
    const result = value >= collateralTokensReq;
    return result;
  }

  export function isSufficientCollateral(
    collateralTokenBalance: bigint,
    decimals: number,
    collateralTokensReq: bigint
  ): boolean {
    const value = (collateralTokenBalance =
      collateralTokenBalance * BigInt(10 ** (18 - decimals)));
    // isSufficientCollateral = Number(collateralTokenBalance) >= Number(collateralTokensReq);
    const result = value >= collateralTokensReq;
    return result;
  }
}
